import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
import { translate } from "../../utils/useful";
import FilterItems from "./FilterItems";
import HubConditionFilterItems from "./HubConditionFilterItems";



class HubConditionBuilder extends Component {

    state = {

        baseData: {
            root: {
                id: 'root',
                action: 'and',
                conditions: {}
            }
        },

        data: {},
        tempData: {},
        items: [],

    }

    componentDidMount() {

        this.init()

    }


    componentDidUpdate(prevProps, prevState) {

        if (prevProps.params != this.props.params) {
            this.init()
        }

        if (!prevProps.data && prevProps.data != this.props.data) {
            this.init()
        }
    }


    init() {

        let current = { level: 0, groupId: 'root', parents: [] }


        if (this.props.data) {
            let data = this.props.data
            if (!data.root) {
                data = this.state.baseData
            }

            this.setState({ data }, () => {

                if (this.state.data?.root?.conditions && Object.keys(this.state.data?.root?.conditions).length == 0) {
                    this.doAdd('con', current)
                }
            })
        } else {
            if (Object.values(this.state.data).length == 0) {
                this.setState({ current, data: this.state.baseData }, () => {
                    this.doAdd('con', current)
                })
            }
        }


        this.setState({ items: this.props.params }, () => {
        });


    }


    doAdd = (type, current) => {
        if (this.fixedView) {
            this.fixedView.hideView()
        }
        let id = nanoid(10)

        let newCondition
        if (type == 'con') {
            newCondition = { id,  operator: null, target: null }
        } else {
            newCondition = { id, action: 'and' }
        }
        let data = this.state.data
        current.id = id


        this.actionOnChild(data, current, newCondition, 'add', 0)


        this.setState({ data: data })
    }


    removeRow = (groupId, id, parents) => {
        let current = { groupId, id, parents }
        let data = this.state.data
        this.actionOnChild(data, current, null, 'remove', 0)
        // if(data?.root&&data?.root?.conditions&&Object.values(data?.root?.conditions).length==0){
        //     data = {}
        // }
        this.setState({ data: data }, () => {
            this.props.changeValue((this.props.header?.key ?? 'data'), data)
        })

    }


    changeInputValue = (key, value, current, extra) => {

        
        let data = this.state.data

        this.actionOnChild(data, current, value, 'update', 0)
        current.value = value//target.value

        // console.log(value)
        // console.log(data)

        this.setState({ data, current }, () => {
            this.props.changeValue((this.props.header?.key ?? 'data'), data, this.props.extra)
        })
    }

    actionOnChild(data, current, value, action, index, cb) {
        if (index == current.parents.length) {

            if (action == 'add') {

                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                if (!data[current.groupId].conditions) {
                    data[current.groupId].conditions = {}
                }
                data[current.groupId].conditions[current.id] = value

            }

            if (action == 'remove') {
                if (current.id == null) {
                    delete data[current.groupId]
                    return data
                } else {
                    delete data[current.groupId].conditions[current.id]
                    return data
                }
            }

            if (action == 'changeOperator') {
                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                data[current.groupId].action = value
            }

            if (action == 'update') {
                data[current.groupId].conditions[current.id][current.key] = value
            }

            if (action == 'get') {
                return data[current.groupId].conditions[current.id][current.key]
            }

        } else if (index < current.parents.length) {
            let newData = data[current.parents[index]]
            if (newData) {
                return this.actionOnChild(newData.conditions, current, value, action, index + 1)
            }
        }
    }


    renderGroup(data, parents, level) {
        if (data) {
            return (
                <div className="position-relative">

                    <div className="" style={{ backgroundColor: "transparent" }}>

                        {data.conditions && Object.values(data.conditions).map((prop, index) => {
                            if (prop) {
                                if (prop.action) {
                                    return (
                                        <div key={prop.id} className="pld-2">
                                            <div className=" pld-3 pb-2 my-2 pt-2" style={{ background: '#fff', color: '#000', borderLeft: '1px solid rgba(0,0,0,0.1)', borderBottom: '1px solid rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.1)', width: "100%", borderRadius: '8px' }} >
                                                {this.renderGroup(prop, [...parents, data.id], level + 1)}
                                            </div>
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <div className="" key={prop.id} >
                                            <HubConditionFilterItems selectedChoose={this.state.selectedChoose} changeAction={this.changeAction} items={this.state.items} renderGroup={this.renderGroup} removeRow={this.removeRow} optionsList={this.props.optionsList} prop={prop} index={index} level={level} data={data} parents={parents} openInput={this.openInput} conditionsLength={Object.values(data.conditions)?.length} changeInputValue={this.changeInputValue} params={this.props.params} variables={this.props.variables} />
                                        </div>

                                    )
                                }

                            }

                        }
                        )}
                    </div >
                    {data.action && (
                        <div className="flexc pt-1" style={{ opacity: '100%' }} >
                            <div ref={el => this['add-' + data.id] = el} className="w-100">
                                <div className="flexc w-100">
                                    <button className="flexc" style={{ border: '0px solid #007aff', width: level > 0 ? '30%' : '50%', maxWidth: 75, }} onClick={() => this.doAdd('con', { level: level, groupId: data.id, parents: parents })}>
                                        <img className="" src="/assets/icons/plus-blue.svg" width="16px" alt="" />
                                        <p className="pld-1 text-smaller font-size-12 email-des" style={{ color: "#007aff", width: '90%' }}>{translate('Condition')}</p>
                                    </button>

                                    <button className="flexc mx-2" style={{ border: '0px solid #007aff', width: level > 0 ? '30%' : '50%', maxWidth: 110, }} onClick={() => this.doAdd('group', { level: level, groupId: data.id, parents: parents })}>
                                        <img className="" src="/assets/icons/plus-blue.svg" width="16px" alt="" />
                                        <p className="pld-1 text-smaller font-size-12 email-des" style={{ color: "#007aff", width: '90%' }}>{translate('Condition group')}</p>
                                    </button>

                                    {level > 0 && (
                                        <button className="mrd-3 flexc" style={{ border: '0px solid #007aff', width: '30%', maxWidth: 90 }} onClick={() => this.removeRow(data.id, null, parents, level)}  >
                                            <p className="text-smaller text-semibold email-des" style={{ color: "#888", width: '100%' }}>{translate("Remove group")}</p>
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )
        }
    }



    render() {

        return (
            <>
                <div className="w-100" ref={el => this.filterEditor = el}  >
                    <div className="w-100" style={{ overflow: "auto" }}>

                        <div>
                            <div className=" pb-2" style={{ maxHeight: "100%", overflow: 'auto' }} >
                                <div className="text-start ">
                                    {this.renderGroup(this.state.data.root, [], 0)}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </>
        )
    }
}

export default HubConditionBuilder;